import React, { useState, useRef, useEffect } from 'react';
import { IoIosPause, IoIosPlay } from 'react-icons/io';
import { FaVolumeDown, FaHeart, FaShareAlt } from 'react-icons/fa';
import styled from 'styled-components';
import Media from 'shared-components/theme/medias';
import colors from 'shared-components/theme/colors';
import Loader from 'components/loader/loader';
const CustomVideoPlayer = ({
    videoSource = '',
    poster,
    title,
    playing,
    setPlaying,
    isControlVisible = false,
    showOverlay = true,
    showVolume = true,
    seekControlWidth,
    showPassedTime = true,
    showCenterBtn = false,
    padding,
    height,
    progressBg,
}) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [volume, setVolume] = useState(0.5);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!playing) {
            videoRef.current.pause();
        }
    }, [playing]);

    const handlePlayPause = () => {
        if (videoRef.current.paused && videoSource !== '') {
            videoRef.current.play();
            setIsPlaying(true);
            setPlaying(true);
        } else {
            videoRef.current.pause();
            setIsPlaying(false);
            setPlaying(false);
        }
    };

    const handleTimeUpdate = () => {
        setCurrentTime(videoRef.current.currentTime);
    };

    const handleSeek = (event) => {
        const seekTime = event.target.value;
        videoRef.current.currentTime = seekTime;
        setCurrentTime(seekTime);
    };

    const handleVolumeChange = (event) => {
        const vol = event.target.value;
        videoRef.current.volume = vol;
        setVolume(vol);
    };

    const formatDuration = (seconds) => {
        const minutes = Math.floor(seconds / 60)
            .toString()
            .padStart(2, '0');
        const secs = Math.floor(seconds % 60)
            .toString()
            .padStart(2, '0');
        return `${minutes}:${secs}`;
    };

    const handleVideoEnd = () => {
        const video = videoRef.current;
        if (video) {
            video.load();
            setIsPlaying(false);
        }
    };

    const handleCanPlay = () => setIsLoading(false);
    const handleWaiting = () => setIsLoading(true);

    return (
        <VideoPlayer
            className="custom-video-player"
            props={isControlVisible}
            isPlaying={isPlaying}>
            {isLoading && (
                <div className="loader">
                    <Loader size="small" />
                </div>
            )}
            {showOverlay && (
                <Overlay className="overlay">
                    <div>
                        <h6>{title}</h6>
                        {/* <p>{title}</p> */}
                    </div>
                    <div className="social">
                        <button>
                            <FaHeart />
                        </button>
                        <button>
                            <FaShareAlt />
                        </button>
                    </div>
                </Overlay>
            )}

            <video
                ref={videoRef}
                onTimeUpdate={handleTimeUpdate}
                poster={poster}
                onEnded={handleVideoEnd}
                onCanPlay={handleCanPlay}
                onWaiting={handleWaiting}
                onLoadStart={() => setIsLoading(true)}
                preload="metadata"
                playsInline
                loading="lazy">
                <source src={videoSource} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            {showCenterBtn && (
                <CenterControlButton
                    className="centerBtn"
                    onClick={handlePlayPause}>
                    {isPlaying && playing ? (
                        <IoIosPause
                            style={{
                                color: '#fff',
                                fontSize: '30px',
                            }}
                        />
                    ) : (
                        <IoIosPlay
                            style={{
                                color: '#fff',
                                fontSize: '30px',
                                marginLeft: '3px',
                            }}
                        />
                    )}
                </CenterControlButton>
            )}
            <Controls
                className="controls"
                props={seekControlWidth}
                padding={padding}
                height={height}
                progressBg={progressBg}>
                <div className="seek__controls">
                    <span
                        onClick={handlePlayPause}
                        style={{ cursor: 'pointer' }}>
                        {isPlaying && playing ? (
                            <IoIosPause
                                style={{ color: '#fff', fontSize: '30px' }}
                            />
                        ) : (
                            <IoIosPlay
                                style={{ color: '#fff', fontSize: '30px' }}
                            />
                        )}
                    </span>
                    {showPassedTime && (
                        <span className="duration current_time">
                            {currentTime == 0 && '00:'}
                            {currentTime ? formatDuration(currentTime) : '00'}
                        </span>
                    )}
                    <div className="progress_container">
                        <div
                            className="watched-bar"
                            style={{
                                width: `${
                                    (currentTime / videoRef.current?.duration) *
                                        100 || 0
                                }%`,
                            }}></div>
                        <input
                            type="range"
                            min={0}
                            max={
                                videoRef.current ? videoRef.current.duration : 0
                            }
                            value={currentTime}
                            onChange={handleSeek}
                        />
                    </div>
                    {!showPassedTime ? (
                        <span className="duration current_time">
                            {currentTime == 0 && '00:'}
                            {currentTime ? formatDuration(currentTime) : '00'}
                        </span>
                    ) : (
                        <span className="duration total_time">
                            {videoRef.current
                                ? formatDuration(videoRef.current.duration)
                                : '00:00'}
                        </span>
                    )}
                </div>
                {/* <span>Volume: {volume?.toFixed(2)}</span> */}
                {showVolume && (
                    <div className="audio__controls">
                        <span style={{ width: '24px', height: '24px' }}>
                            <FaVolumeDown
                                style={{ color: '#fff', fontSize: '24px' }}
                            />
                        </span>
                        <input
                            type="range"
                            min={0}
                            max={1}
                            step={0.01}
                            value={volume}
                            onChange={handleVolumeChange}
                        />
                    </div>
                )}
            </Controls>
        </VideoPlayer>
    );
};

const VideoPlayer = styled.div`
    position: relative;
    text-align: center;

    video {
        // position: absolute ;
        // top : 0;
        // left : 0;
        // min-width : 1280px;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        overflow: hidden;
    }

    .overlay,
    .controls,
    .centerBtn {
        opacity: ${(props) => (props.props ? 1 : 0)};
        visibility: ${(props) => (props.props ? 'visible' : 'hidden')};
        transition: 0.3s ease;

        ${(props) =>
            props.isPlaying &&
            `
            opacity: 0;
            visibility: hidden;
        `}
    }

    &:hover {
        .overlay,
        .controls,
        .centerBtn {
            opacity: 1;
            visibility: visible;
        }
    }

    .loader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        div {
            min-height: auto;
        }
    }
`;

const Overlay = styled.div`
    position: absolute;
    top: 60px;
    width: 90%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 99;
    h6 {
        color: #fff;
        font-size: 29px;
        margin: 0;
        font-weight: 600;
        text-align: left;
    }

    p {
        color: #fff;
        font-size: 20px;
        margin: 0;
        text-align: left;
    }

    button {
        display: block;
        background: transparent;
        border: 0;
        color: #fff;
        font-size: 30px;
    }

    ${Media('xlscreens')} {
        h6 {
            font-size: 1.51vw;
        }
        p {
            font-size: 1.094vw;
        }
    }
    ${Media('tablet')} {
        top: 0px;
        width: 98%;
        h6 {
            font-size: 20px;
        }

        p {
            font-size: 16px;
        }
        svg {
            font-size: 16px;
        }
    }
`;
const CenterControlButton = styled.div`
    height: 70px;
    width: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid ${colors.geoWhite[100]};
    background-color: #04291452;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    transition: 0.3s ease;
    &:hover {
        background-color: ${colors.geoGreen[100]};
    }
    ${Media('mobile')} {
        height: 50px;
        width: 50px;
    }
`;
const Controls = styled.div`
    text-align : left;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    z-index: 99;
    display : flex; 
    justify-content : space-between;
    align-items: center;
    padding : ${(props) => props.padding || '20px 20px 60px'};

    &:before {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 110%;
        height: 110%;
        background: linear-gradient(to top, #0000003b, transparent);
        z-index: -1;
    }

    .duration{
        font-size  12px;
    }
    button {
        display : inline-block;
        background : transparent;
        border : 0;
        color : #fff; 
        font-size : 30px;
    }

    .seek__controls {
        // flex : 4.7;
        display : flex; 
        justify-content : space-between;
        align-items: center;
        width : ${(props) => props.props || '89%'};
        gap : 10px;
        margin :auto;

        .progress_container {
            position: relative;
            width: 100%;
            margin: 0 0 8px;
            flex : 1;
            .watched-bar {
                position: absolute;
                height: 3px;
                background-color: ${(props) =>
                    props.progressBg || colors.pink[100]};
                top: 68%;
                transform: translateY(-50%);
                left: 2px;
                pointer-events: none;
                z-index: 2;
            }
        }
    }
    span {
        color : #fff;
    }
    .audio__controls {
        // flex : 1;
        text-align : right;
        width : 10%;
        display : flex;
        justify-content : flex-end;
        align-items : center;
        gap : 10px;
    }

    .seek__controls input[type="range"] {
        
        display : inline-block;
        cursor : pointer;
        -webkit-appearance: none;
        appearance: none;
        // background: transparent;
        cursor: pointer;
        width : 100%;
        height : ${(props) => props.height || ''};
        &::-webkit-slider-runnable-track {
            background: rgba(250, 250, 250, 0.5) !important;
            height: 1.5px;
        }


       &::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 14px;
        height: 14px;
        border-radius: 10px;
        background-color: rgb(255, 255, 255);
        overflow: visible;
        cursor: pointer;
        margin-top: -6px;
    }
     
    }
    .audio__controls input[type="range"] {
        cursor : pointer;
        -webkit-appearance: none;
        appearance: none;
        width : 100%;
        &::-webkit-slider-runnable-track {
            background: rgba(250, 250, 250, 0.5) !important;
            height: 1.5px;
        }
        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            width: 14px;
            height: 14px;
            border-radius: 10px;
            background-color: rgb(255, 255, 255);
            overflow: visible;
            cursor: pointer;
            margin-top: -6px;
        }

        svg {
            font-size : 16px !important;
        }
     }

     ${Media('xlscreens')} {
        .duration{
            font-size  .8vw;
        }
     }
     ${Media('tablet')} {
        flex-direction : column;
        align-items: flex-start;
        width: 98%;
        bottom : 10px;
        padding: 0;
        .audio__controls {
            width : auto;
        }
    
`;
export default CustomVideoPlayer;
